import {gql} from "@apollo/client";
import {client} from "graphql/client";

// 创建财务团队
export const CREATE_ACCOUNT_FINANCIAL_TEAM = gql`
    mutation CreateAccountFinancialTeam($input: AccountFinancialTeamInput!) {
        createAccountFinancialTeam(input: $input)
    }
`;

// 更新财务团队
export const UPDATE_ACCOUNT_FINANCIAL_TEAM = gql`
    mutation UpdateAccountFinancialTeam($input: AccountFinancialTeamInput!) {
        updateAccountFinancialTeam(input: $input)
    }
`;

export interface AccountFinancialTeamInput {
    id?: string;
    email?: string;
    countryCode: number;
    phone?: string;
    password?: string;
    name: string;
    avatarStorageToken?: string;
    status: number;
    role?: string;
}

export const createAccountFinancialTeam = async (input: AccountFinancialTeamInput): Promise<boolean> => {
    const {data} = await client.mutate({
        mutation: CREATE_ACCOUNT_FINANCIAL_TEAM,
        variables: {input}
    });
    return data.createAccountFinancialTeam;
};

export const updateAccountFinancialTeam = async (input: AccountFinancialTeamInput): Promise<boolean> => {
    const {data} = await client.mutate({
        mutation: UPDATE_ACCOUNT_FINANCIAL_TEAM,
        variables: {input}
    });
    return data.updateAccountFinancialTeam;
};
